import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import API from "../../../services/api";
import "./transport.css";

export default function BusList() {
  const school   = JSON.parse(localStorage.getItem("schoolAdmin"));
  const navigate = useNavigate();

  const [buses,   setBuses]   = useState([]);
  const [loading, setLoading] = useState(true);

  const load = async () => {
    try {
      setLoading(true);
      const res = await API.get("/school-admin/buses/", {
        headers: { "X-SCHOOL-ID": school.school.id },
      });
      setBuses(res.data.buses || []);
    } catch (err) { console.error(err); }
    finally { setLoading(false); }
  };

  useEffect(() => { load(); }, []);

  const deleteBus = async (id) => {
    if (!window.confirm("Delete this bus? This cannot be undone.")) return;
    try {
      await API.delete(`/school-admin/buses/delete/${id}/`, {
        headers: { "X-SCHOOL-ID": school.school.id },
      });
      load();
    } catch (err) { console.error(err); alert("Failed to delete bus"); }
  };

  return (
    <div className="tr-page">

      {/* ══ HERO ══ */}
      <div className="tr-hero">
        <div className="tr-hero-left">
          <div className="tr-hero-icon">🚍</div>
          <div>
            <h2 className="tr-hero-title">Bus Management</h2>
            <p className="tr-hero-sub">
              {loading ? "Loading…" : `${buses.length} bus${buses.length !== 1 ? "es" : ""} registered`}
            </p>
          </div>
        </div>
        <div className="tr-hero-right">
          <button className="tr-btn-add" onClick={() => navigate("/school-admin/transport/buses/add")}>
            + Add Bus
          </button>
        </div>
      </div>

      {/* ══ BUS GRID ══ */}
      {loading ? (
        <div className="tr-empty">
          <div className="tr-empty-icon">⏳</div>
          <strong>Loading buses…</strong>
        </div>
      ) : buses.length === 0 ? (
        <div className="tr-empty">
          <div className="tr-empty-icon">🚌</div>
          <strong>No buses yet</strong>
          <p style={{ marginTop:8, fontSize:13 }}>Add your first school bus to get started</p>
        </div>
      ) : (
        <div className="tr-grid">
          {buses.map(b => {
            const occupied = b.occupied_seats || 0;
            const total    = b.total_seats    || 0;
            const pct      = total > 0 ? Math.round((occupied / total) * 100) : 0;
            return (
              <div key={b.id} className="tr-card">
                <div className="tr-card-top">
                  <span className="tr-card-num">🚍 {b.bus_number}</span>
                  <span className="tr-card-seats-pill">{occupied}/{total} seats</span>
                </div>
                <p className="tr-card-route">📍 {b.route_name}</p>

                <div className="tr-progress-wrap">
                  <div className="tr-progress-label">{pct}% occupied</div>
                  <div className="tr-progress-bar">
                    <div className="tr-progress-fill" style={{ width:`${pct}%` }} />
                  </div>
                </div>

                <div className="tr-card-actions">
                  <button className="tr-btn-view" onClick={() => navigate(`/school-admin/transport/buses/${b.id}`)}>
                    👁 View
                  </button>
                  <button className="tr-btn-edit" onClick={() => navigate(`/school-admin/transport/buses/edit/${b.id}`)}>
                    ✏️ Edit
                  </button>
                  <button className="tr-btn-del" onClick={() => deleteBus(b.id)}>
                    🗑 Delete
                  </button>
                </div>
              </div>
            );
          })}
        </div>
      )}

    </div>
  );
}
